{
  "familyId": "TOPO-WERELD-LANDEN",
  "questions": [
    {
      "id": "TOPO-WERELD-LANDEN-001",
      "familyId": "TOPO-WERELD-LANDEN",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_landen_wereld",
      "questionType": "multiple_choice",
      "question": "Welk land heeft de meeste inwoners ter wereld?",
      "options": [
        "India",
        "China",
        "Verenigde Staten",
        "Brazilië"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grootste landen (bevolking)",
            "content": "India heeft sinds 2023 de meeste inwoners (>1,4 miljard), gevolgd door China. De VS staat op plaats 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_bevolking",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "India heeft sinds 2023 de meeste inwoners ter wereld met meer dan 1,4 miljard mensen. China stond lang op de eerste plaats, maar is nu ingehaald. De VS staat op de derde plaats met ongeveer 330 miljoen inwoners.",
        "solutionSteps": [
          "India: >1,4 miljard inwoners (nummer 1 sinds 2023)",
          "China: ~1,4 miljard (nummer 2)",
          "VS: ~330 miljoen (nummer 3)"
        ],
        "distractorExplanations": {
          "0": "Goed! India heeft sinds 2023 de meeste inwoners ter wereld, meer dan 1,4 miljard.",
          "1": "China was lang het grootste land qua bevolking, maar India heeft China in 2023 ingehaald. Onthoud: India is nu nummer 1.",
          "2": "De VS heeft ~330 miljoen inwoners — veel minder dan India of China. Onthoud: VS is nummer 3.",
          "3": "Brazilië heeft ~215 miljoen inwoners. Groot, maar niet de grootste. Onthoud: Brazilië is het grootste land van Zuid-Amerika."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-001-OPT1",
            "optionIndex": 1,
            "label": "Onthoud: India is nu nummer 1"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-001-OPT2",
            "optionIndex": 2,
            "label": "Onthoud: VS is nummer 3"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-001-OPT3",
            "optionIndex": 3,
            "label": "Brazilië heeft ~215 miljoen inwoners"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_landen_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-LANDEN-002",
      "familyId": "TOPO-WERELD-LANDEN",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_landen_wereld",
      "questionType": "multiple_choice",
      "question": "Op welk continent ligt Egypte?",
      "options": [
        "Afrika",
        "Azië",
        "Europa",
        "Zuid-Amerika"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Egypte",
            "content": "Egypte ligt in het noordoosten van Afrika. Het Suezkanaal vormt de grens met Azië. De hoofdstad is Caïro.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_egypte",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Egypte ligt in het noordoosten van Afrika, aan de Middellandse Zee. Het Suezkanaal vormt de grens met Azië. De hoofdstad Caïro ligt aan de Nijl, de langste rivier van Afrika.",
        "solutionSteps": [
          "Egypte = noordoost-Afrika",
          "Grens met Azië via Suezkanaal",
          "Hoofdstad: Caïro, aan de Nijl"
        ],
        "distractorExplanations": {
          "0": "Goed! Egypte ligt in het noordoosten van Afrika, aan de Middellandse Zee en de Nijl.",
          "1": "Egypte grenst aan Azië via het Suezkanaal, maar het land zelf ligt in Afrika. Het Sinaï-schiereiland ligt wel in Azië.",
          "2": "Egypte ligt niet in Europa. Het ligt aan de andere kant van de Middellandse Zee. Onthoud: Afrika = zuidkant van de Middellandse Zee.",
          "3": "Zuid-Amerika ligt aan de andere kant van de wereld. Egypte ligt in Afrika. Onthoud: Egypte = piramides = Afrika."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-002-OPT1",
            "optionIndex": 1,
            "label": "Het Sinaï-schiereiland ligt wel in Azië"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-002-OPT2",
            "optionIndex": 2,
            "label": "Egypte ligt niet in Europa"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-002-OPT3",
            "optionIndex": 3,
            "label": "Egypte ligt in Afrika"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_landen_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-LANDEN-003",
      "familyId": "TOPO-WERELD-LANDEN",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_landen_wereld",
      "questionType": "multiple_choice",
      "question": "Welk land is qua oppervlakte het grootste ter wereld?",
      "options": [
        "Rusland",
        "Canada",
        "China",
        "Australië"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grootste landen (oppervlakte)",
            "content": "Rusland is veruit het grootste land (17,1 miljoen km²). Canada is nummer 2 (10 miljoen km²). Rusland strekt zich uit over Europa én Azië.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_oppervlakte",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Rusland is het grootste land ter wereld met 17,1 miljoen km². Het strekt zich uit van Europa tot aan de Stille Oceaan.",
        "solutionSteps": [
          "Rusland: 17,1 miljoen km²",
          "Canada: 10 miljoen km² (nummer 2)"
        ],
        "distractorExplanations": {
          "0": "Goed! Rusland is het grootste land.",
          "1": "Canada is het op één na grootste land. Groot, maar kleiner dan Rusland. Onthoud: Rusland = nummer 1.",
          "2": "China is het derde of vierde grootste land. Onthoud: Rusland > Canada > VS/China.",
          "3": "Australië is groot maar kleiner dan Rusland, Canada en China. Onthoud: Australië is het grootste eiland/continent."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-003-OPT1",
            "optionIndex": 1,
            "label": "Canada is het op één na grootste land"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-003-OPT2",
            "optionIndex": 2,
            "label": "China is het derde of vierde grootste land"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Australië"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_landen_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-LANDEN-004",
      "familyId": "TOPO-WERELD-LANDEN",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_landen_wereld",
      "questionType": "multiple_choice",
      "question": "Welk land wordt ook wel 'het land van de rijzende zon' genoemd?",
      "options": [
        "Japan",
        "China",
        "Thailand",
        "Zuid-Korea"
      ],
      "correctAnswer": 0,
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Japan",
            "content": "Japan wordt 'het land van de rijzende zon' genoemd. De Japanse vlag toont een rode zon. Japan ligt in het oosten van Azië.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_japan",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Japan wordt 'het land van de rijzende zon' genoemd. De naam komt van de Japanse naam 'Nihon' (oorsprong van de zon). De vlag toont een rode zon.",
        "solutionSteps": [
          "Japan = land van de rijzende zon",
          "Japanse vlag = rode zon"
        ],
        "distractorExplanations": {
          "0": "Goed! Japan = land van de rijzende zon.",
          "1": "China wordt soms 'het Rijk van het Midden' genoemd, niet de rijzende zon. Onthoud: Japan = zon, China = midden.",
          "2": "Thailand wordt 'het land van de glimlach' genoemd. Onthoud: Japan = zon.",
          "3": "Zuid-Korea wordt 'het land van de ochtendkalmte' genoemd. Onthoud: Japan = rijzende zon."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-004-OPT1",
            "optionIndex": 1,
            "label": "Onthoud: Japan = zon, China = midden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-004-OPT2",
            "optionIndex": 2,
            "label": "Onthoud: Japan = zon"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-WERELD-LANDEN-004-OPT3",
            "optionIndex": 3,
            "label": "Onthoud: Japan = rijzende zon"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_landen_wereld"
          }
        }
      ]
    },
    {
      "id": "TOPO-WERELD-LANDEN-005",
      "familyId": "TOPO-WERELD-LANDEN",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "wereld",
      "subSkill": "topo_landen_wereld",
      "questionType": "matching",
      "question": "Koppel elk land aan het juiste continent.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          "Brazilië",
          "Nigeria",
          "India",
          "Australië"
        ],
        "rightItems": [
          "Azië",
          "Afrika",
          "Oceanië",
          "Zuid-Amerika"
        ],
        "correctMatches": {
          "0": 3,
          "1": 1,
          "2": 0,
          "3": 2
        }
      },
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Landen en continenten",
            "content": "Brazilië = Zuid-Amerika, Nigeria = Afrika, India = Azië, Australië = Oceanië.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "wereld_continenten_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Elk van deze landen ligt op een ander continent. Brazilië is het grootste land van Zuid-Amerika. Nigeria is het volkrijkste land van Afrika. India ligt in Azië en heeft de meeste inwoners ter wereld. Australië is zowel een land als een continent en hoort bij Oceanië.",
        "solutionSteps": [
          "Brazilië = Zuid-Amerika (grootste land)",
          "Nigeria = Afrika (volkrijkste land)",
          "India = Azië (meeste inwoners ter wereld)",
          "Australië = Oceanië (land én continent)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van wereld",
            "region": "wereld",
            "highlight": "topo_landen_wereld"
          }
        }
      ]
    }
  ]
}